// extracted by mini-css-extract-plugin
export default {"container":"join-workspace_container__kSZC0","card":"join-workspace_card__I4HzX","header":"join-workspace_header__chRJQ","body":"join-workspace_body__E9NE7"};